import VueRouter from "vue-router";

import ConstituicaoEstadual from "../views/ConstituicaoEstadual";
import PesquisaLegislacao from "../views/pesquisa_legislacao/PesquisaLegislacao";
import PorAno from "../views/pesquisa_legislacao/PorAno";
import PorAutor from "../views/pesquisa_legislacao/PorAutor";
import PorCategoria from "../views/pesquisa_legislacao/PorCategoria";
import PorTipo from "../views/pesquisa_legislacao/PorTipo";
import PesquisaLegislacaoShow from "../views/pesquisa_legislacao/PesquisaLegislacaoShow";
import PesquisaAtoInfralegalShow from "../views/pesquisa_ato_infralegal/PesquisaAtoInfralegalShow";
import PesquisaAtoInfralegal from "../views/pesquisa_ato_infralegal/PesquisaAtoInfralegal";
import PorAnoAtoInfralegal from "../views/pesquisa_ato_infralegal/PorAnoAtoInfralegal";
import PorTipoAtoInfralegal from "../views/pesquisa_ato_infralegal/PorTipoAtoInfralegal";
import PorOrgaoAtoInfralegal from "../views/pesquisa_ato_infralegal/PorOrgaoAtoInfralegal";
import PesquisaMensagemVeto from "../views/pesquisa_mensagem_veto/PesquisaMensagemVeto";
import PesquisaMensagemVetoShow from "../views/pesquisa_mensagem_veto/PesquisaMensagemVetoShow";
import PesquisaIndexAtoAdministrativo from "../views/pesquisa_index_ato_administrativo/PesquisaIndexAtoAdministrativo";
import ProjetosGovernador from "../views/pesquisa_projeto_governador/ProjetosGovernador";
import PorTipoVetoMensagemVeto from "../views/pesquisa_mensagem_veto/PorTipoVetoMensagemVeto";
import PorAnoMensagemVeto from "../views/pesquisa_mensagem_veto/PorAnoMensagemVeto";
import PorTipoLegislacaoMensagemVeto from "../views/pesquisa_mensagem_veto/PorTipoLegislacaoMensagemVeto";
import PorAnoProjetoGovernador from "../views/pesquisa_projeto_governador/PorAnoProjetoGovernador";
import PorAnoAtoAdministrativo from "../views/pesquisa_index_ato_administrativo/PorAnoAtoAdministrativo";
import PorTipoAtoAdministrativo from "../views/pesquisa_index_ato_administrativo/PorTipoAtoAdministrativo";
import EntendaLegislacao from "../views/EntendaLegislacao";
import NaoEncontrado from "../views/NaoEncontrado";
import CadastroAcompanhamentoPublicacoes from "../views/CadastroAcompanhamentoPublicacoes";
import DescadastroAcompanhamentoPublicacoes from "../views/DescadastroAcompanhamentoPublicacoes";
import AlteraAcompanhamentoPublicacoes from "../views/AlteraAcompanhamentoPublicacoes";
import PesquisaLegislacaoMunicipal from "../views/pesquisa_legislacao_municipal/legislacao_municipal/PesquisaLegislacaoMunicipal";
import LegislacaoPorEnteFederativo from "../views/pesquisa_legislacao_municipal/legislacao_municipal/LegislacaoPorEnteFederativo";
import PorAnoMunicipal from "../views/pesquisa_legislacao_municipal/legislacao_municipal/PorAnoMunicipal.vue";
import PorTipoMunicipal from "../views/pesquisa_legislacao_municipal/legislacao_municipal/PorTipoMunicipal.vue";
import PorAutorMunicipal from "../views/pesquisa_legislacao_municipal/legislacao_municipal/PorAutorMunicipal.vue";
import PorCategoriaMunicipal from "../views/pesquisa_legislacao_municipal/legislacao_municipal/PorCategoriaMunicipal.vue";
import AtosInfralegaisPorEnteFederativo from "../views/pesquisa_legislacao_municipal/atos_infralegais/AtosInfralegaisPorEnteFederativo";
import MensagensVetoPorEnteFederativo from "../views/pesquisa_legislacao_municipal/mensagens_veto/MensagensVetoPorEnteFederativo";
import AtosAdministrativosPorEnteFederativo from "../views/pesquisa_legislacao_municipal/atos_administrativos/AtosAdministrativosPorEnteFederativo";
import AtosAdministrativosPorEnteFederativoPorTipo from "../views/pesquisa_legislacao_municipal/atos_administrativos/AtosAdministrativosPorEnteFederativoPorTipo.vue";
import AtosAdministrativosPorEnteFederativoPorAno from "../views/pesquisa_legislacao_municipal/atos_administrativos/AtosAdministrativosPorEnteFederativoPorAno.vue";
import AtosInfralegaisPorEnteFederativoPorTipo from "../views/pesquisa_legislacao_municipal/atos_infralegais/AtosInfralegaisPorEnteFederativoPorTipo.vue";
import AtosInfralegaisPorEnteFederativoPorAno from "../views/pesquisa_legislacao_municipal/atos_infralegais/AtosInfralegaisPorEnteFederativoPorAno.vue";
import AtosInfralegaisPorEnteFederativoPorOrgao from "../views/pesquisa_legislacao_municipal/atos_infralegais/AtosInfralegaisPorEnteFederativoPorOrgao.vue";
import PesquisaAtoInfralegalMunicipalShow from "../views/pesquisa_legislacao_municipal/atos_infralegais/PesquisaAtoInfralegalMunicipalShow.vue";
import PesquisaMensagemVetoMunicipalShow from "../views/pesquisa_legislacao_municipal/mensagens_veto/PesquisaMensagemVetoMunicipalShow.vue";
import MensagensVetoPorEnteFederativoPorTipoVeto from "../views/pesquisa_legislacao_municipal/mensagens_veto/MensagensVetoPorEnteFederativoPorTipoVeto.vue";
import MensagensVetoPorEnteFederativoPorAno from "../views/pesquisa_legislacao_municipal/mensagens_veto/MensagensVetoPorEnteFederativoPorAno.vue";
import MensagensVetoPorEnteFederativoPorTipoLegislacao from "../views/pesquisa_legislacao_municipal/mensagens_veto/MensagensVetoPorEnteFederativoPorTipoLegislacao.vue";
import PesquisaLegislacaoMunicipalShow from "../views/pesquisa_legislacao_municipal/legislacao_municipal/PesquisaLegislacaoMunicipalShow";
import NovoManualDeRedacao from "../views/NovoManualDeRedacao";


const router = new VueRouter({
  routes: [
    {
      path: "/pesquisa_ato_infralegal/:orgaoSlug/:id(\\d+)/:slug?", // Canonical route (orgaoSlug required)
      component: PesquisaAtoInfralegalShow,
      name: "PesquisaAtoInfralegalShow",
      props: true,
    },
    {
      path: "/pesquisa_ato_infralegal/:id(\\d+)/:slug?", // Old URL pattern
      name: "PesquisaAtoInfralegalOld",
      beforeEnter: async (to, from, next) => {
        const atoId = to.params.id;
        try {
          const response = await fetch(`${process.env.VUE_APP_BASE_API_URL}/api/v1/pesquisa/atos_infralegais/${atoId}`);
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          const data = await response.json();
          const orgaoSlug = data.orgao_relacionado_sigla;

          if (orgaoSlug) {
            next({
              name: "PesquisaAtoInfralegalShow",
              params: {
                orgaoSlug: orgaoSlug,
                id: atoId,
                slug: to.params.slug || ''
              },
              replace: true
            });
          } else {
            next({ name: "NaoEncontrado", query: { url: to.fullPath } });
          }
        } catch (error) {
          console.error("Error fetching orgaoSlug for redirect:", error);
          next({ name: "NaoEncontrado", query: { url: to.fullPath } });
        }
      },
    },
    // As rotas fixas precisam vir antes de "/pesquisa_ato_infralegal/:orgaoSlug?",
    // senão, ao carregar a URL diretamente, "por-orgao" etc. são tratados como slug de órgão.
    {
      path: "/pesquisa_ato_infralegal/por-ano",
      component: PorAnoAtoInfralegal,
      name: "PorAnoAtoInfralegal",
    },
    {
      path: "/pesquisa_ato_infralegal/por-tipo",
      component: PorTipoAtoInfralegal,
      name: "PorTipoAtoInfralegal",
    },
    {
      path: "/pesquisa_ato_infralegal/por-orgao",
      component: PorOrgaoAtoInfralegal,
      name: "PorOrgaoAtoInfralegal",
    },
    {
      path: "/pesquisa_ato_infralegal/:orgaoSlug?",
      component: PesquisaAtoInfralegal,
      name: "PesquisaAtoInfralegal",
      props: true,
    },
    // Alias de nome para contexto municipal usando o mesmo caminho e componente
    {
      path: "/pesquisa_ato_infralegal/:orgaoSlug?/:id(\\d+)/:slug?",
      component: PesquisaAtoInfralegalShow,
      name: "AtosInfralegaisPorEnteFederativoShow",
      meta: { isMunicipalLegislation: true, pageClass: 'page-legislacao-municipal' },
      props: true,
    },
    {
      path: "/pesquisa_legislacao",
      component: PesquisaLegislacao,
      name: "PesquisaLegislacao",
      alias: "/",
    },
    {
      path: "/pesquisa_legislacao/por-ano",
      component: PorAno,
      name: "PorAnoLegislacao",
    },
    {
      path: "/pesquisa_legislacao/por-tipo",
      component: PorTipo,
      name: "PorTipoLegislacao",
    },
    {
      path: "/pesquisa_legislacao/por-autor",
      component: PorAutor,
      name: "PorAutorLegislacao",
    },
    {
      path: "/pesquisa_legislacao/por-categoria",
      component: PorCategoria,
      name: "PorCategoriaLegislacao",
    },
    {
      path: "/pesquisa_legislacao/:id/:slug?",
      component: PesquisaLegislacaoShow,
      name: "PesquisaLegislacaoShow",
    },
    {
      path: "/constituicao-estadual",
      component: ConstituicaoEstadual,
      name: "ConstituicaoEstadual",
    },
    {
      path: "/pesquisa_mensagem_veto",
      component: PesquisaMensagemVeto,
      name: "PesquisaMensagemVeto",
    },
    {
      path: "/pesquisa_mensagem_veto/por-tipo-veto",
      component: PorTipoVetoMensagemVeto,
      name: "PorTipoVetoMensagemVeto",
    },
    {
      path: "/pesquisa_mensagem_veto/por-ano",
      component: PorAnoMensagemVeto,
      name: "PorAnoMensagemVeto",
    },
    {
      path: "/pesquisa_mensagem_veto/por-tipo-legislacao",
      component: PorTipoLegislacaoMensagemVeto,
      name: "PorTipoLegislacaoMensagemVeto",
    },
    {
      path: "/pesquisa_mensagem_veto/:id/:slug?",
      component: PesquisaMensagemVetoShow,
      name: "PesquisaMensagemVetoShow",
    },
    {
      path: "/pesquisa_ato_administrativo",
      component: PesquisaIndexAtoAdministrativo,
      name: "PesquisaIndexAtoAdministrativo",
    },
    {
      path: "/pesquisa_ato_administrativo/por-ano",
      component: PorAnoAtoAdministrativo,
      name: "PorAnoAtoAdministrativo",
    },
    {
      path: "/pesquisa_ato_administrativo/por-tipo",
      component: PorTipoAtoAdministrativo,
      name: "PorTipoAtoAdministrativo",
    },
    {
      path: "/projetos-governador",
      component: ProjetosGovernador,
      name: "ProjetosGovernador",
    },
    {
      path: "/projetos-governador/por-ano",
      component: PorAnoProjetoGovernador,
      name: "PorAnoProjetoGovernador",
    },
    {
      path: "/entenda_legislacao",
      component: EntendaLegislacao,
      name: "EntendaLegislacao",
      alias: "/entenda-legislacao",
    },
    {
      path: "/cadastro-acompanhamento-publicacoes",
      component: CadastroAcompanhamentoPublicacoes,
      name: "CadastroAcompanhamentoPublicacoes",
    },
    {
      path: "/descadastro-acompanhamento-publicacoes",
      component: DescadastroAcompanhamentoPublicacoes,
      name: "DescadastroAcompanhamentoPublicacoes",
    },
    {
      path: "/novo-manual-de-redacao",
      component: NovoManualDeRedacao,
      name: "NovoManualDeRedacao",
    },
    {
      path: "/altera-acompanhamento-publicacoes",
      component: AlteraAcompanhamentoPublicacoes,
      name: "AlteraAcompanhamentoPublicacoes",
    },    
    {
      path: "/legislacao_municipal",
      component: PesquisaLegislacaoMunicipal,
      name: "PesquisaLegislacaoMunicipal",
      meta: { isMunicipalLegislation: true, pageClass: 'page-legislacao-municipal' },
    },
    {
      path: "/:slug/pesquisa_legislacao", // Top-level route
      component: LegislacaoPorEnteFederativo,
      name: "LegislacaoPorEnteFederativoBySlug",
      props: true,
      meta: { isMunicipalLegislation: true, pageClass: 'page-legislacao-municipal' },
    },
    {
      path: "/:slug/pesquisa_legislacao/por-ano",
      component: PorAnoMunicipal,
      name: "LegislacaoPorEnteFederativoPorAno",
      props: (route) => ({ slug: route.params.slug }),
       meta: { isMunicipalLegislation: true, pageClass: 'page-legislacao-municipal' },
    },
    {
      path: "/:slug/pesquisa_legislacao/por-tipo",
      component: PorTipoMunicipal,
      name: "LegislacaoPorEnteFederativoPorTipo",
      props: (route) => ({ slug: route.params.slug }),
      meta: { isMunicipalLegislation: true, pageClass: 'page-legislacao-municipal' },
    },
    {
      path: "/:slug/pesquisa_legislacao/por-autor",
      component: PorAutorMunicipal,
      name: "LegislacaoPorEnteFederativoPorAutor",
      props: (route) => ({ slug: route.params.slug }),
      meta: { isMunicipalLegislation: true, pageClass: 'page-legislacao-municipal' },
    },
    {
      path: "/:slug/pesquisa_legislacao/por-categoria",
      component: PorCategoriaMunicipal,
      name: "LegislacaoPorEnteFederativoPorCategoria",
      props: (route) => ({ slug: route.params.slug }),
      meta: { isMunicipalLegislation: true, pageClass: 'page-legislacao-municipal' },
    },
    {
      path: "/:slug/pesquisa_ato_infralegal/:orgaoSlug?",
      component: AtosInfralegaisPorEnteFederativo,
      name: "AtosInfralegaisPorEnteFederativo",
      props: true,
      meta: { isMunicipalLegislation: true, pageClass: 'page-legislacao-municipal' },
    },
    
    
    {
      path: "/:slug/pesquisa_mensagem_veto",
      component: MensagensVetoPorEnteFederativo,
      name: "MensagensVetoPorEnteFederativo",
      props: true,
      meta: { isMunicipalLegislation: true, pageClass: 'page-legislacao-municipal' },
    },
    {
      path: "/:slug/pesquisa_mensagem_veto/por-tipo-veto",
      component: MensagensVetoPorEnteFederativoPorTipoVeto,
      name: "MensagensVetoPorEnteFederativoPorTipoVeto",
      props: true,
      meta: { isMunicipalLegislation: true, pageClass: 'page-legislacao-municipal' },
    },
    {
      path: "/:slug/pesquisa_mensagem_veto/por-tipo-legislacao",
      component: MensagensVetoPorEnteFederativoPorTipoLegislacao,
      name: "MensagensVetoPorEnteFederativoPorTipoLegislacao",
      props: true,
      meta: { isMunicipalLegislation: true, pageClass: 'page-legislacao-municipal' },
    },
    {
      path: "/:slug/pesquisa_mensagem_veto/por-ano",
      component: MensagensVetoPorEnteFederativoPorAno,
      name: "MensagensVetoPorEnteFederativoPorAno",
      props: true,
      meta: { isMunicipalLegislation: true, pageClass: 'page-legislacao-municipal' },
    },
    {
      path: "/:slug/pesquisa_ato_administrativo",
      component: AtosAdministrativosPorEnteFederativo,
      name: "AtosAdministrativosPorEnteFederativo",
      props: true,
      meta: { isMunicipalLegislation: true, pageClass: 'page-legislacao-municipal' },
    },
    {
      path: "/:slug/pesquisa_ato_administrativo/por-tipo",
      component: AtosAdministrativosPorEnteFederativoPorTipo,
      name: "AtosAdministrativosPorEnteFederativoPorTipo",
      props: true,
      meta: { isMunicipalLegislation: true, pageClass: 'page-legislacao-municipal' },
    },
    {
      path: "/:slug/pesquisa_ato_administrativo/por-ano",
      component: AtosAdministrativosPorEnteFederativoPorAno,
      name: "AtosAdministrativosPorEnteFederativoPorAno",
      props: true,
      meta: { isMunicipalLegislation: true, pageClass: 'page-legislacao-municipal' },
    },
    {
      path: "/:slug/pesquisa_ato_infralegal/por-tipo",
      component: AtosInfralegaisPorEnteFederativoPorTipo,
      name: "AtosInfralegaisPorEnteFederativoPorTipo",
      props: true,
      meta: { isMunicipalLegislation: true, pageClass: 'page-legislacao-municipal' },
    },
    {
      path: "/:slug/pesquisa_ato_infralegal/por-ano",
      component: AtosInfralegaisPorEnteFederativoPorAno,
      name: "AtosInfralegaisPorEnteFederativoPorAno",
      props: true,
      meta: { isMunicipalLegislation: true, pageClass: 'page-legislacao-municipal' },
    },
    {
      path: "/:slug/pesquisa_ato_infralegal/por-orgao",
      component: AtosInfralegaisPorEnteFederativoPorOrgao,
      name: "AtosInfralegaisPorEnteFederativoPorOrgao",
      props: true,
      meta: { isMunicipalLegislation: true, pageClass: 'page-legislacao-municipal' },
    },
    {
      path: "/:slug/pesquisa_mensagem_veto/:id/:documentSlug?",
      component: PesquisaMensagemVetoMunicipalShow,
      name: "PesquisaMensagemVetoMunicipalShow",
      props: true,
    },
    {
      path: "/:slug/pesquisa_ato_infralegal/:id/:documentSlug?",
      component: PesquisaAtoInfralegalMunicipalShow,
      name: "PesquisaAtoInfralegalMunicipalShow",
      props: true,
    },
    {
      path: "/:slug/pesquisa_legislacao/:id/:documentSlug?",
      component: PesquisaLegislacaoMunicipalShow,
      name: "PesquisaLegislacaoMunicipalShow",
      props: true,
      meta: { isMunicipalLegislation: true },
    },
    





    {
      name: "NaoEncontrado",
      path: "/nao-encontrado",
      component: NaoEncontrado,
    },
    {
      path: "*",
      beforeEnter: (to, _from, next) => {
        // Não intercepta rotas de API do backend
        if (to.path.includes('/api/')) {
          // Recarrega a página para permitir que o backend processe a requisição
          window.location.href = to.fullPath;
        } else {
          next({ name: "NaoEncontrado", query: { url: to.path } });
        }
      },
    },
  ],
  mode: "history",
  scrollBehavior(to, from) {
    if (
      "PesquisaLegislacao" === to.name &&
      [
        "PorAnoLegislacao",
        "PorTipoLegislacao",
        "PorAutorLegislacao",
        "PorCategoriaLegislacao",
      ].includes(from.name)
    ) {
      return { selector: "#resultados" };
    }

    if (
      "PesquisaAtoInfralegal" === to.name &&
      [
        "PorTipoAtoInfralegal",
        "PorOrgaoAtoInfralegal",
        "PorAnoAtoInfralegal",
      ].includes(from.name)
    ) {
      return { selector: "#resultados" };
    }

    if (
      "PesquisaMensagemVeto" === to.name &&
      [
        "PorTipoVetoMensagemVeto",
        "PorAnoMensagemVeto",
        "PorTipoLegislacaoMensagemVeto",
      ].includes(from.name)
    ) {
      return { selector: "#resultados" };
    }

    if (
      "ProjetosGovernador" === to.name &&
      "PorAnoProjetoGovernador" === from.name
    ) {
      return { selector: "#resultados" };
    }

    if (
      "PesquisaIndexAtoAdministrativo" === to.name &&
      ["PorAnoAtoAdministrativo", "PorTipoAtoAdministrativo"].includes(
        from.name
      )
    ) {
      return { selector: "#resultados" };
    }

    if (
      "LegislacaoPorEnteFederativo" === to.name &&
      [
        "LegislacaoPorEnteFederativoPorAno",
        "LegislacaoPorEnteFederativoPorTipo",
        "LegislacaoPorEnteFederativoPorAutor",
        "LegislacaoPorEnteFederativoPorCategoria",
      ].includes(from.name)
    ) {
      return { selector: "#resultados" };
    }

    if (
      "AtosAdministrativosPorEnteFederativo" === to.name &&
      [
        "AtosAdministrativosPorEnteFederativoPorAno",
        "AtosAdministrativosPorEnteFederativoPorTipo",
      ].includes(from.name)
    ) {
      return { selector: "#resultados" };
    }

    if (
      "AtosInfralegaisPorEnteFederativo" === to.name &&
      [
        "AtosInfralegaisPorEnteFederativoPorAno",
        "AtosInfralegaisPorEnteFederativoPorTipo",
      ].includes(from.name)
    ) {
      return { selector: "#resultados" };
    }



    return { x: 0, y: 0 };
  },
});

export default router;
